import type {
  Benefit,
  Brand,
  Category,
  FooterColumn,
  HeroSlide,
  Product
} from "../types/marketplace";

export const categories: Category[] = [
  { name: "Electr\u00f3nica", icon: "\u{1F4F1}", color: "#3483fa" },
  { name: "Moda", icon: "\u{1F455}", color: "#ec3b91" },
  { name: "Hogar", icon: "\u{1F3E0}", color: "#ff9800", active: true },
  { name: "Deportes", icon: "\u{1F3CB}\uFE0F", color: "#00b65a" },
  { name: "Belleza", icon: "\u2728", color: "#a044ff" },
  { name: "Ni\u00f1os", icon: "\u{1F9F8}", color: "#00bcd4" },
  { name: "Veh\u00edculos", icon: "\u{1F697}", color: "#ff3045" },
  { name: "Herramientas", icon: "\u{1F527}", color: "#60748a" },
  { name: "Supermercado", icon: "\u{1F6D2}", color: "#61c900" }
];

export const heroSlides: HeroSlide[] = [
  {
    eyebrow: "EXCLUSIVO",
    title: "Env\u00edo Gratis",
    description: "En compras mayores a $50",
    cta: "Comprar ahora",
    background: "linear-gradient(135deg, #ff8515, #f24500)"
  },
  {
    eyebrow: "OFERTA FLASH",
    title: "Tecnolog\u00eda hasta 40% OFF",
    description: "Celulares, audio y accesorios seleccionados",
    cta: "Ver ofertas",
    background: "linear-gradient(135deg, #2563eb, #0f172a)"
  },
  {
    eyebrow: "NUEVA TEMPORADA",
    title: "Hogar renovado",
    description: "Deco, muebles y organizadores con env\u00edo full",
    cta: "Explorar hogar",
    background: "linear-gradient(135deg, #00a36c, #073b2a)"
  }
];

export const benefits: Benefit[] = [
  {
    icon: "\u{1F69A}",
    title: "Env\u00edo gratis",
    description: "En miles de productos"
  },
  {
    icon: "\u{1F6E1}\uFE0F",
    title: "Compra segura",
    description: "Protecci\u00f3n al comprador"
  },
  {
    icon: "\u{1F4B3}",
    title: "6 cuotas sin inter\u00e9s",
    description: "En productos seleccionados"
  },
  {
    icon: "\u{1F3A7}",
    title: "Soporte 24/7",
    description: "Te ayudamos siempre"
  }
];

export const brands: Brand[] = [
  { name: "TechPro", category: "Electr\u00f3nica", letter: "T", color: "#2563eb" },
  { name: "ModaStyle", category: "Moda", letter: "M", color: "#ec3b91" },
  { name: "HomeVibe", category: "Hogar", letter: "H", color: "#ff7a00" },
  { name: "SportMax", category: "Deportes", letter: "S", color: "#00b65a" },
  { name: "BeautyGlow", category: "Belleza", letter: "B", color: "#8b3ffc" },
  { name: "KidZone", category: "Ni\u00f1os", letter: "K", color: "#0ea5b7" }
];

export const products: Product[] = [
  {
    id: "auriculares-pro",
    name: "Auriculares Inal\u00e1mbricos Pro con Cancelaci\u00f3n de Ruido",
    price: 89.99,
    oldPrice: 129.99,
    discount: "-31% OFF",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=700&q=80",
    sales: "+5.420 vendidos",
    rating: "2.847",
    full: true
  },
  {
    id: "smartwatch-elite",
    name: "Smartwatch Elite Series 5 GPS + Cellular",
    price: 199.99,
    oldPrice: 249.99,
    discount: "-20% OFF",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=700&q=80",
    sales: "+3.210 vendidos",
    rating: "1.523",
    full: true
  },
  {
    id: "chaqueta-urbana",
    name: "Chaqueta Urbana Premium Impermeable",
    price: 79.99,
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?auto=format&fit=crop&w=700&q=80",
    sales: "+1.840 vendidos",
    rating: "892"
  },
  {
    id: "zapatillas-running",
    name: "Zapatillas Running Air Max Ultra Boost",
    price: 129.99,
    oldPrice: 179.99,
    discount: "-28% OFF",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=700&q=80",
    sales: "+8.930 vendidos",
    rating: "4.521",
    full: true
  },
  {
    id: "lampara-led",
    name: "L\u00e1mpara de Mesa LED Moderna T\u00e1ctil",
    price: 45.99,
    image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?auto=format&fit=crop&w=700&q=80",
    sales: "+1.200 vendidos",
    rating: "567"
  },
  {
    id: "skincare-premium",
    name: "Set de Skincare Premium Completo Anti-Age",
    price: 65.99,
    oldPrice: 99.99,
    discount: "-34% OFF",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=700&q=80",
    sales: "+4.560 vendidos",
    rating: "2.103",
    full: true
  },
  {
    id: "mochila-usb",
    name: "Mochila Escolar Ergon\u00f3mica con USB",
    price: 34.99,
    image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?auto=format&fit=crop&w=700&q=80",
    sales: "+2.340 vendidos",
    rating: "789"
  },
  {
    id: "camara-4k",
    name: "C\u00e1mara Digital Mirrorless 4K Pro",
    price: 749.99,
    oldPrice: 899.99,
    discount: "-17% OFF",
    image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&w=700&q=80",
    sales: "+890 vendidos",
    rating: "1.245",
    full: true
  },
  {
    id: "vestido-midi",
    name: "Vestido Casual Elegante Midi",
    price: 59.99,
    image: "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?auto=format&fit=crop&w=700&q=80",
    sales: "+1.560 vendidos",
    rating: "456"
  },
  {
    id: "pesas-ajustables",
    name: "Set de Pesas Ajustables 2-24kg",
    price: 149.99,
    oldPrice: 199.99,
    discount: "-25% OFF",
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=700&q=80",
    sales: "+2.100 vendidos",
    rating: "892",
    full: true
  },
  {
    id: "organizador-bambu",
    name: "Organizador de Escritorio Bamb\u00fa Premium",
    price: 39.99,
    image: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=700&q=80",
    sales: "+890 vendidos",
    rating: "345"
  },
  {
    id: "paleta-sombras",
    name: "Paleta de Sombras Luxury Edition 24 Tonos",
    price: 42.99,
    oldPrice: 59.99,
    discount: "-28% OFF",
    image: "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?auto=format&fit=crop&w=700&q=80",
    sales: "+7.890 vendidos",
    rating: "3.456"
  },
  {
    id: "tablet-pro",
    name: "Tablet Pro 11 256GB WiFi + Stylus",
    price: 599.99,
    oldPrice: 699.99,
    discount: "-14% OFF",
    image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=700&q=80",
    sales: "+3.450 vendidos",
    rating: "1.890",
    full: true
  },
  {
    id: "aspiradora-robot",
    name: "Aspiradora Robot WiFi con Mapeo L\u00e1ser",
    price: 299.99,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=700&q=80",
    sales: "+4.560 vendidos",
    rating: "2.345",
    full: true
  },
  {
    id: "bicicleta-spinning",
    name: "Bicicleta Spinning Pro con Pantalla HD",
    price: 399.99,
    image: "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?auto=format&fit=crop&w=700&q=80",
    sales: "+890 vendidos",
    rating: "567"
  },
  {
    id: "perfume-intense",
    name: "Perfume Eau de Parfum Intense 100ml",
    price: 89.99,
    oldPrice: 120,
    discount: "-25% OFF",
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?auto=format&fit=crop&w=700&q=80",
    sales: "+2.890 vendidos",
    rating: "1.234"
  }
];

export const footerBenefits: Benefit[] = [
  {
    icon: "\u{1F69A}",
    title: "Env\u00edo a todo el pa\u00eds",
    description: "Gratis en miles de productos"
  },
  {
    icon: "\u{1F4B3}",
    title: "Todos los medios de pago",
    description: "Hasta 6 cuotas sin inter\u00e9s"
  },
  {
    icon: "\u{1F6E1}\uFE0F",
    title: "Compra protegida",
    description: "Garant\u00eda de devoluci\u00f3n"
  }
];

export const footerColumns: FooterColumn[] = [
  {
    title: "Comprar",
    links: ["C\u00f3mo comprar", "Env\u00edos", "Medios de pago", "Garant\u00eda"]
  },
  {
    title: "Vender",
    links: ["C\u00f3mo vender", "Registrarse como vendedor", "Publicar productos"]
  },
  {
    title: "Ayuda",
    links: ["Centro de ayuda", "Preguntas frecuentes", "Contacto"]
  },
  {
    title: "Legal",
    links: ["T\u00e9rminos y condiciones", "Privacidad", "Defensa del consumidor"]
  }
];
